var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustrystar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_49)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M42.9962 40.0253L70 35.0442L42.8216 30.4124L50.2504 19.6626L39.8506 27.0915L34.9558 0L30.324 27.2654L19.6619 19.6626L27.0038 30.4117L0 35.0442L27.0045 40.0253L19.6626 50.3381L30.3247 42.9962L34.9565 70L39.9376 43.1716L50.2504 50.3374L42.9962 40.0253Z",
    fill: "#744DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrystar);
export default __webpack_public_path__ + "static/media/industrystar.a61f405d7c8883da7d783b7fe0cf48cb.svg";
export { ForwardRef as ReactComponent };